import type {InjectionKey} from "vue";

export const IsResponderContextInjectionKey: InjectionKey<boolean> = Symbol("isResponderContext");
